import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Base } from './core/components/base/base';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/component/login/login-module').then((m) => m.LoginModule),
  },
  {
    path: '',
    component: Base,
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/component/dashboard/dashboard').then((m) => m.Dashboard),
        canActivate: [AuthGuard]
      },
      {
        path: 'sites',
        loadChildren: () =>
          import('./features/component/sites/sites-module').then((m) => m.SitesModule),
        canActivate: [AuthGuard]
      },
    ]
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
